export class PortalConstService {
    public static readonly SPORTSBOOK: string = 'SPORTSBOOK';
    public static readonly BETTING: string = 'BETTING';
    public static readonly CASINO: string = 'CASINO';
    public static readonly POKER: string = 'POKER';
}
